import { getTreeNodeChildren, getTreeNodeId, type TreeNode } from './treeNode'

export const findNodeById = <T extends TreeNode>(
  nodes: T[],
  id: string
): T | null => {
  for (const node of nodes) {
    if (getTreeNodeId(node) === id) return node

    const found = findNodeById(getTreeNodeChildren(node), id)
    if (found) return found
  }
  return null
}
